<template>
  <div class="model_header filterContent">
    <div class="flex">
      <div class="flex1 text-align-left symbolContainer">
        <span class="model_title">提现金额</span>
        <!-- 评分组件 -->
        <br />
        <span class="symbol">
          ￥
        </span>
        <input type="number" v-model="_price" class="withDrawInput">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['property', 'changeWithDrawValue', 'withDrawValue'],
  name: 'Bill',
  data() {
    return {
      price: '',
    };
  },
  watch: {
    withDrawValue(newVal) {
      this.price = newVal.toString();
    },
  },
  computed: {
    _price: {
      set: function(value) {
        this.price = value;
      },
      get: function() {
        console.log(this.price);
        let dotPos = this.price.indexOf('.');
        let newVal = '';
        if (dotPos > -1 && this.price.length - dotPos > 3) {
          [newVal] = this.price.match(/\d+\.\d{2}/);
        } else {
          newVal = parseFloat(this.price);
          if (newVal !== newVal) {
            // NaN
            newVal = 0;
          }
        }
        this.changeWithDrawValue(newVal);
        return newVal;
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.withDrawInput {
  height: 0.5rem;
  border: none;
  outline: none;
  width: calc(100% - 1rem);
  font-size: 0.4rem;
}
.symbol {
  position: relative;
  display: inline-block;
  font-size: 0.2rem;
  font-weight: 600;
  top: -0.1rem;
}
.symbolContainer {
  border-bottom: 1px solid #cdcdcd;
}
.filterContent {
  height: fit-content;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/userWithDrawElement/Header.vue